import type { IconData } from '@stacksjs/iconify-core'

export const shareLinkRemix: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M30.25 12.5a6.5 6.5 0 1 1 13 0a6.5 6.5 0 0 1-13 0M36.75 2c-5.799 0-10.5 4.701-10.5 10.5q0 .77.108 1.51l-7.21 3.07a10.48 10.48 0 0 0-7.898-3.58C5.451 13.5.75 18.201.75 24s4.701 10.5 10.5 10.5c3.148 0 5.973-1.385 7.897-3.58l7.21 3.071q-.106.74-.107 1.509c0 5.799 4.701 10.5 10.5 10.5s10.5-4.701 10.5-10.5S42.549 25 36.75 25c-3.131 0-5.943 1.37-7.867 3.545l-7.234-3.081a10.6 10.6 0 0 0 0-2.927l7.235-3.082A10.48 10.48 0 0 0 36.75 23c5.799 0 10.5-4.701 10.5-10.5S42.549 2 36.75 2m-32 22a6.5 6.5 0 1 1 13 0a6.5 6.5 0 0 1-13 0m32 5a6.5 6.5 0 1 0 0 13a6.5 6.5 0 0 0 0-13\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default shareLinkRemix
